import ImageBlockCarouselBlock from './ImageBlockCarouselBlock';

export default ImageBlockCarouselBlock;
